import { createContext, useContext } from 'react'
import { DefaultAdminRolesRequiredPerAction } from '@nv/utils'
import { useTranslation } from 'react-i18next'

export const ConfigurationContext = createContext()

export const getDefaultConfiguration = (t) => {
  return {
    languages: {
      en: 'English',
      fr: 'Francais',
    },
    votingMethodOptions: [
      { label: t('admin.electorsList.votedChannelOptions.online'), value: 'online' },
      { label: t('admin.electorsList.votedChannelOptions.mail'), value: 'mail' },
    ],
    electionDate: new Date(),
    minAge: 18,
    registrationPhoneRequired: false,
    includeSingleNameField: false,
    maxSessionTimeMinsAdmin: 30,
    maxSessionTimeMinsVoter: 30,
    votingDistrictOptions: [],
    knownIdNumberTextFieldConfig: {},
    enableManualEntryAddress: true,
    enableSingleFieldMailingAddress: false,
    enableDifferentMailingAddress: true,
    mailingAddressRequiredVoteByMail: false,
    registrationOpensDate: '2025-01-20T00:00:00',
    strikeOffButtonEnabled: true,
    displayStrikeOffOnlyVotingChannels: [],
    adminRolesPerAction: DefaultAdminRolesRequiredPerAction,
    contactInfoHelpSupport: false,
    contactInfoHelpSupportData: {},
    includeLoginButtonRegistrationPage: true,
    defaultVotingMethod: '',
    registeredOnlinefilterOptionsSelectMulti: false,
    registeredOnlinefilterOptions: [
      {
        key: 'statusFilter',
        label: t('admin.electorsList.status'),
        options: [
          { value: 'All', label: t('main.all') },
          { value: 'Pending', label: t('registration.registrationStatus.pending'), default: true },
          { value: 'Approved', label: t('registration.registrationStatus.approved') },
          { value: 'Declined', label: t('registration.registrationStatus.declined') },
        ],
      },
      {
        key: 'channelFilter',
        label: t('admin.electorsList.votingChannel'),
        options: [
          { value: 'all', label: t('main.all') },
          { value: 'online', label: t('admin.electorsList.votedChannelOptions.online') },
          { value: 'inPerson', label: t('admin.electorsList.votedChannelOptions.inPerson') },
          { value: 'mail', label: t('admin.electorsList.votedChannelOptions.mail') },
        ],
      },
      {
        key: 'districtFilter',
        label: t('admin.electorsList.votingDistrict'),
        options: [{ value: 'All', label: t('main.all') }],
      },
    ],
    eligibleListfilterOptionsSelectMulti: false,
    eligibleListfilterOptions: [
      {
        key: 'channelFilter',
        label: t('admin.electorsList.votingChannel'),
        options: [
          { value: 'all', label: t('main.all') },
          { value: 'online', label: t('admin.electorsList.votedChannelOptions.online') },
          { value: 'inPerson', label: t('admin.electorsList.votedChannelOptions.inPerson') },
          { value: 'mail', label: t('admin.electorsList.votedChannelOptions.mail') },
        ],
      },
      {
        key: 'districtFilter',
        label: t('admin.electorsList.votingDistrict'),
        options: [{ value: 'All', label: t('main.all') }],
      },
      {
        key: 'statusFilter',
        label: t('admin.electorsList.eligibleVoterStatus'),
        options: [
          { value: 'all', label: t('main.all') },
          { value: 'voted', label: t('admin.electorsList.eligibleVoterStatusOptions.voted') },
          { value: 'registered', label: t('admin.electorsList.eligibleVoterStatusOptions.registered') },
          { value: 'removed', label: t('admin.electorsList.eligibleVoterStatusOptions.removed') },
        ],
      },
    ],
    includeOnlineVoterAuth: true,
    registrationIncludeSupportingDocument: true,
    includeKnownIdNumber: true,
  }
}

export const ConfigurationContextProvider = ({ children }) => {
  const { t } = useTranslation()
  const defaultConfiguration = getDefaultConfiguration(t)

  return <ConfigurationContext.Provider value={defaultConfiguration}>{children}</ConfigurationContext.Provider>
}

export const useConfigurationContext = () => {
  const context = useContext(ConfigurationContext)
  return context
}

export default ConfigurationContext
